import { useState } from 'react';

import {
  BpkAccordion,
  BpkAccordionItem,
} from '@skyscanner/backpack-web/bpk-component-accordion';
import BpkText, {
  TEXT_STYLES,
} from '@skyscanner/backpack-web/bpk-component-text';
import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import type { I18nService } from '@shared/types/i18n';

import STYLES from './LegalDisclaimerAccordion.module.scss';

import LegalDisclaimerLinkButton from '@shared/ui/components/LegalDisclaimerLinkButton';
import { withI18n } from '@shared/ui/contexts/i18n';

const cls = cssModules(STYLES);
const LegalDisclaimerAccordion = ({
  i18n: { translate },
}: {
  i18n: I18nService;
}) => {
  const [sortOrderExpanded, setSortOrderExpanded] = useState(false);
  const [priceChangeExpanded, setPriceChangeExpanded] = useState(false);
  const onSortOrderClick = () => {
    setSortOrderExpanded((prevState) => !prevState);
  };
  const onPriceChangeClick = () => {
    setPriceChangeExpanded((prevState) => !prevState);
  };
  return (
    <div className={cls('LegalDisclaimerAccordion')}>
      <BpkAccordion className={cls('LegalDisclaimerAccordion__accordion')}>
        <BpkAccordionItem
          id="default_sort_order"
          title={translate(
            'HotelDetails_hops_legal_disclaimer_whatDefaultOrder',
          )}
          expanded={sortOrderExpanded}
          onClick={onSortOrderClick}
          textStyle={TEXT_STYLES.label1}
        >
          <BpkText textStyle={TEXT_STYLES.bodyDefault} tagName="p">
            {translate('HotelDetails_hops_legal_disclaimer_dealsSorted')}
            <LegalDisclaimerLinkButton
              inlineStyle
              textStyle={TEXT_STYLES.bodyDefault}
              className={cls('LegalDisclaimerAccordion__linkButton')}
            />
          </BpkText>
        </BpkAccordionItem>
      </BpkAccordion>
      <BpkAccordion
        className={cls(
          'LegalDisclaimerAccordion__accordion',
          'LegalDisclaimerAccordion__accordionHideOnMobile',
        )}
      >
        <BpkAccordionItem
          id="learn_about_price_change"
          title={translate('MetaPrice_consistency_linkMessage')}
          expanded={priceChangeExpanded}
          onClick={onPriceChangeClick}
          textStyle={TEXT_STYLES.label1}
        >
          <BpkText>
            {translate('MetaPrice_consistency_tipsDescription')}
          </BpkText>
          <BpkText textStyle={TEXT_STYLES.label1}>
            {translate('MetaPrice_consistency_tipsRemind')}
          </BpkText>
        </BpkAccordionItem>
      </BpkAccordion>
    </div>
  );
};

export default withI18n(LegalDisclaimerAccordion);
